module.exports = __webpack_public_path__ + "static/media/workflowWitnessLogo.d7b9eb19.webp";